export enum AssetCategory {
  BANKS = 'BANKS',
  MUTUAL_FUNDS = 'MUTUAL_FUNDS',
  STOCKS = 'STOCKS',
  FIXED_DEPOSIT = 'FIXED_DEPOSIT',
  NPS = 'NPS',
}

export const FI_TYPES = {
  DEPOSIT: 'DEPOSIT',
  MUTUAL_FUNDS: 'MUTUAL_FUNDS',
  EQUITIES: 'EQUITIES',
  ETF: 'ETF',
  TERM_DEPOSIT: 'TERM_DEPOSIT',
  TERM_DEPOSIT_HYPHEN: 'TERM-DEPOSIT',
  RECURRING_DEPOSIT: 'RECURRING_DEPOSIT',
  NPS: 'NPS',
};

export const isAccountOfCategory = (
  fiType: string,
  category: AssetCategory
): boolean => {
  switch (category) {
    case AssetCategory.BANKS:
      return fiType === FI_TYPES.DEPOSIT;
    case AssetCategory.MUTUAL_FUNDS:
      return fiType === FI_TYPES.MUTUAL_FUNDS;
    case AssetCategory.STOCKS:
      return fiType === FI_TYPES.EQUITIES || fiType === FI_TYPES.ETF;
    case AssetCategory.FIXED_DEPOSIT:
      return (
        fiType === FI_TYPES.TERM_DEPOSIT ||
        fiType === FI_TYPES.TERM_DEPOSIT_HYPHEN ||
        fiType === FI_TYPES.RECURRING_DEPOSIT
      );
    case AssetCategory.NPS:
      return fiType === FI_TYPES.NPS;
    default:
      return false;
  }
};
